import React from "react";

export const useDetectOverflow = (
  id: string
): [boolean, (b: boolean) => void] => {
  const [overflow, setOverflow] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      const element = document.getElementById(id);
      if (element) {
        if (element.scrollWidth > element.offsetWidth) {
          setOverflow(true);
        } else if (element.offsetWidth === 0) {
          setOverflow(true);
        } else {
          setOverflow(false);
        }
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id]);

  return [
    React.useMemo(() => overflow, [overflow]),
    React.useCallback(setOverflow, [setOverflow])
  ];
};